import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { userComponent } from './user.component';
import { FormsModule } from '@angular/forms';
import { WaitLoadingModule } from '../../components/common/waitLoading/waitLoading.module';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng-lts/tooltip';

@NgModule({
    declarations: [userComponent],
    imports: [TranslateModule, CommonModule, FormsModule, WaitLoadingModule, TooltipModule],
    exports: [userComponent]
})

export class UserModule { }